// imove-branch: 上报方法是否存在



export default async function(ctx) {
  const { reportIns = null } = ctx.context
  if (reportIns?.dataReport) {
    return true;
  }
  return false;
}